import {
  COMMISSIONS_POLICIES_ADD_INCENTIVES_BEGIN,
  COMMISSIONS_POLICIES_ADD_INCENTIVES_SUCCESS,
  COMMISSIONS_POLICIES_ADD_INCENTIVES_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_POLICIES_ADD_INCENTIVES_BEGIN:
      return {
        ...state,
        policies: {
          ...state.policies,
          createComissionPolicyPending: true,
          createComissionPolicyError: null,
        }
      }

    case COMMISSIONS_POLICIES_ADD_INCENTIVES_SUCCESS:
      return {
        ...state,
        policies: {
          ...state.policies,
          createComissionPolicyPending: false,
          createComissionPolicyError: null,
          incentivesSuccess: true
        }
      }

    case COMMISSIONS_POLICIES_ADD_INCENTIVES_FAILURE:
      return {
        ...state,
        policies: {
          ...state.policies,
          createComissionPolicyPending: false,
          createComissionPolicyError: true
        }
      }

    default:
      return state
  }
}
